export default "__VITE_ASSET__DSIAqW1b__"